import NewClientDialog from './NewClientDialog'

export default NewClientDialog
